import React, {
  useMemo,
  useState,
  useEffect,
} from "react";

import { useNavigate } from "react-router-dom";

import { TfiLocationPin } from "react-icons/tfi";

import "../../../Styles/EmployeejobList.css";

import ApiService from "../../../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

function EmployeejobList() {

  const [page, setPage] = useState(1);

  const pageSize = 4;

  const navigate = useNavigate();

  /* =========================================
      STATES
  ========================================= */

  const [jobs, setJobs] = useState([]);

  const [loading, setLoading] =
    useState(false);

  const [searchInput, setSearchInput] =
    useState("");

  const [selectedIds, setSelectedIds] =
    useState([]);

  /* =========================================
      LOAD DATA
  ========================================= */

  useEffect(() => {

    loadApprovedJobs();

  }, []);

  /* =========================================
      LOAD APPROVED JOBS
  ========================================= */

  const loadApprovedJobs =
    async () => {

      try {

        setLoading(true);

        /* =====================================
            GET ALL JOBS
        ===================================== */

        const response =
          await JobAPI.getAdminAllJobs();

        console.log(
          "ADMIN ALL JOBS RESPONSE :",
          response?.data
        );

        let apiJobs = [];

        /* =====================================
            HANDLE ALL RESPONSE TYPES
        ===================================== */

        if (
          Array.isArray(response?.data)
        ) {

          apiJobs =
            response.data;

        } else if (
          Array.isArray(
            response?.data?.jobs
          )
        ) {

          apiJobs =
            response.data.jobs;

        } else if (
          Array.isArray(
            response?.data?.data
          )
        ) {

          apiJobs =
            response.data.data;

        } else {

          apiJobs = [];
        }

        console.log(
          "RAW API JOBS :",
          apiJobs
        );

        /* =====================================
            FILTER APPROVED JOBS
        ===================================== */

        const approvedJobs =
          apiJobs.filter((job) => {

            const role = String(
              job.creator_role || ""
            ).toUpperCase();

            const status = String(
              job.status || ""
            ).toUpperCase();

            return (

              (
                role === "HR" ||
                role === "EMPLOYEE"
              )

              &&

              status === "APPROVED"
            );
          });

        console.log(
          "APPROVED JOBS :",
          approvedJobs
        );

        /* =====================================
            FETCH APPLICATION COUNTS
        ===================================== */

        const jobsWithCounts =
          await Promise.all(

            approvedJobs.map(
              async (job) => {

                const jobId =
                  job.job_id ||
                  job.id;

                let applications =
                  [];

                try {

                  console.log(
                    "FETCH APPLICATIONS FOR JOB :",
                    jobId
                  );

                  const appResponse =
                    await JobAPI.getApplicationsByJob(
                      jobId
                    );

                  console.log(
                    `APPLICATIONS FOR JOB ${jobId} :`,
                    appResponse?.data
                  );

                  /* =============================
                      HANDLE ALL RESPONSE TYPES
                  ============================= */

                  if (
                    Array.isArray(
                      appResponse?.data
                    )
                  ) {

                    applications =
                      appResponse.data;

                  } else if (
                    Array.isArray(
                      appResponse?.data?.applications
                    )
                  ) {

                    applications =
                      appResponse.data.applications;

                  } else if (
                    Array.isArray(
                      appResponse?.data?.data
                    )
                  ) {

                    applications =
                      appResponse.data.data;

                  } else {

                    applications =
                      [];
                  }

                } catch (error) {

                  console.log(
                    `APPLICATION FETCH ERROR FOR JOB ${jobId}`,
                    error?.response?.data || error
                  );

                  applications =
                    [];
                }

                console.log(
                  `FINAL APPLICATIONS COUNT FOR JOB ${jobId} :`,
                  applications.length
                );

                /* =================================
                    COUNTS
                ================================= */

                const totalResponses =
                  applications.length;

                const shortlisted =
                  applications.filter(
                    (c) => {

                      const status =
                        String(
                          c?.status || ""
                        ).toLowerCase();

                      return (
                        status ===
                        "shortlisted"
                      );
                    }
                  ).length;

                const rejected =
                  applications.filter(
                    (c) => {

                      const status =
                        String(
                          c?.status || ""
                        ).toLowerCase();

                      return (
                        status ===
                        "rejected"
                      );
                    }
                  ).length;

                return {

                  /* =============================
                      IDS
                  ============================= */

                  id:
                    job.job_id ||
                    job.id ||
                    "",

                  job_id:
                    job.job_id ||
                    job.id ||
                    "",

                  /* =============================
                      JOB DETAILS
                  ============================= */

                  title:
                    job.title || "",

                  company_name:
                    job.company_name ||
                    "",

                  department:
                    job.department ||
                    "",

                  work_mode:
                    job.work_mode ||
                    "",

                  roles_responsibilities:
                    job.roles_responsibilities ||
                    "",

                  required_skills:
                    job.required_skills ||
                    "",

                  qualification_required:
                    job.qualification_required ||
                    "",

                  min_experience:
                    Number(
                      job.min_experience || 0
                    ),

                  max_experience:
                    Number(
                      job.max_experience || 0
                    ),

                  min_salary:
                    Number(
                      job.min_salary || 0
                    ),

                  max_salary:
                    Number(
                      job.max_salary || 0
                    ),

                  perks_benefits:
                    job.perks_benefits ||
                    "",

                  location:
                    job.location || "",

                  locality:
                    job.locality || "",

                  openings:
                    Number(
                      job.openings || 0
                    ),

                  application_deadline:
                    job.application_deadline ||
                    "",

                  whatsapp_number:
                    job.whatsapp_number ||
                    "",

                  /* =============================
                      HR DETAILS
                  ============================= */

                  hrName:
                    job.employee_name ||
                    job.created_by_name ||
                    job.hr_name ||
                    job.created_by ||
                    "HR User",

                  memberId:
                    job.created_by ||
                    job.hr_member_id ||
                    job.member_id ||
                    job.createdBy ||
                    "N/A",

                  creator_role:
                    job.creator_role ||
                    "",

                  /* =============================
                      STATUS
                  ============================= */

                  status:
                    job.status ||
                    "APPROVED",

                  admin:
                    job.status ||
                    "APPROVED",

                  postedDate:
                    job.created_at ||
                    "",

                  created_at:
                    job.created_at ||
                    "",

                  /* =============================
                      APPLICATIONS
                  ============================= */

                  applications:
                    applications,

                  /* =============================
                      COUNTS
                  ============================= */

                  all_responses:
                    totalResponses,

                  shortlisted:
                    shortlisted,

                  rejected:
                    rejected,
                };
              }
            )
          );

        console.log(
          "FORMATTED JOBS :",
          jobsWithCounts
        );

        setJobs(jobsWithCounts);

        localStorage.setItem(
          "EmployeeApprovedJobs",
          JSON.stringify(
            jobsWithCounts
          )
        );

      } catch (error) {

        console.log(
          "LOAD JOBS ERROR :",
          error?.response?.data || error
        );

        console.log(
          "LOAD JOBS STATUS :",
          error?.response?.status
        );

        const storedJobs =
          JSON.parse(
            localStorage.getItem(
              "EmployeeApprovedJobs"
            )
          ) || [];

        setJobs(storedJobs);

      } finally {

        setLoading(false);
      }
    };

  /* =========================================
      FILTER JOBS
  ========================================= */

  const filteredJobs =
    useMemo(() => {

      return jobs.filter(
        (job) =>

          job.title
            ?.toLowerCase()
            .includes(
              searchInput.toLowerCase()
            )

          ||

          job.location
            ?.toLowerCase()
            .includes(
              searchInput.toLowerCase()
            )

          ||

          job.company_name
            ?.toLowerCase()
            .includes(
              searchInput.toLowerCase()
            )
      );

    }, [jobs, searchInput]);

  /* =========================================
      PAGINATION
  ========================================= */

  const totalPages =
    Math.ceil(
      filteredJobs.length /
      pageSize
    );

  const currentJobs =
    useMemo(() => {

      const startIndex =
        (page - 1) *
        pageSize;

      return filteredJobs.slice(
        startIndex,
        startIndex + pageSize
      );

    }, [filteredJobs, page]);

  /* =========================================
      SELECT ALL
  ========================================= */

  const allSelected =

    currentJobs.length > 0 &&

    currentJobs.every((job) =>
      selectedIds.includes(job.id)
    );

  const handleToggleSelectAll =
    (e) => {

      setSelectedIds(

        e.target.checked

          ? currentJobs.map(
              (job) => job.id
            )

          : []
      );
    };

  /* =========================================
      SINGLE SELECT
  ========================================= */

  const handleToggleSelect =
    (id) => {

      setSelectedIds((prev) =>

        prev.includes(id)

          ? prev.filter(
              (x) => x !== id
            )

          : [...prev, id]
      );
    };

  /* =========================================
      DELETE
  ========================================= */

  const handleDelete =
    () => {

      if (!selectedIds.length) {

        alert(
          "Please select item(s) to delete"
        );

        return;
      }

      if (
        !window.confirm(
          `Delete ${selectedIds.length} job(s)?`
        )
      ) {

        return;
      }

      const updatedJobs =
        jobs.filter(
          (job) =>
            !selectedIds.includes(
              job.id
            )
        );

      setJobs(updatedJobs);

      localStorage.setItem(
        "EmployeeApprovedJobs",
        JSON.stringify(
          updatedJobs
        )
      );

      setSelectedIds([]);

      setPage(1);
    };

  /* =========================================
      PREVIEW
  ========================================= */

  const handlePreview =
    (job) => {

      navigate(
        "/dashboard/Employeejobpost",
        {
          state: { job },
        }
      );
    };

  /* =========================================
      VIEW RESPONSES
  ========================================= */

  const handleViewResponses =
    (job) => {

      console.log(
        "OPEN RESPONSE PAGE :",
        job
      );

      console.log(
        "APPLICATIONS :",
        job.applications
      );

      navigate(
        `/dashboard/Empresponse/${job.id}`,
        {
          state: {

            jobTitle:
              job.title,

            jobId:
              job.id,

            applications:
              job.applications || [],

            totalResponses:
              job.all_responses || 0,
          },
        }
      );
    };

  /* =========================================
      UI
  ========================================= */

  return (

    <section className="adminjobpost">

      <div className="container">

        <h3
          className="training-title mt-2 fw-bold"
          style={{
            color: "#8D0000",
          }}
        >
          Employee Job Posts
        </h3>

        {/* =========================================
            TOTAL JOBS
        ========================================= */}

        <div className="d-flex justify-content-between mb-3">

          <h5 className="text-muted">

            Total Approved Jobs :-

            {" "}

            {filteredJobs.length}

            {" "}of{" "}

            {jobs.length}

          </h5>

        </div>

        {/* =========================================
            ACTION BAR
        ========================================= */}

        <div className="bg-light border rounded-3 p-3 mb-4 d-flex flex-wrap align-items-center gap-3">

          {/* SELECT ALL */}

          <div className="form-check">

            <input
              type="checkbox"
              className="form-check-input job-checkbox"
              checked={allSelected}
              onChange={
                handleToggleSelectAll
              }
            />

            <label className="form-check-label ms-1 admin-select">

              Select All

            </label>

          </div>

          {/* SEARCH */}

          <div className="flex-grow-1 d-flex gap-2">

            <input
              type="text"
              className="form-control"
              placeholder="Search by Job Title or Location..."
              value={searchInput}
              onChange={(e) => {

                setSearchInput(
                  e.target.value
                );

                setPage(1);

              }}
            />

            <button className="admin-serch">
              Search
            </button>

          </div>

          {/* DELETE */}

          <button
            className="admin-delt"
            onClick={handleDelete}
          >

            Delete {selectedIds.length}

          </button>

        </div>

        {/* =========================================
            LOADING
        ========================================= */}

        {loading && (

          <div className="text-center py-5">

            <h5>
              Loading Approved Jobs...
            </h5>

          </div>

        )}

        {/* =========================================
            JOB CARDS
        ========================================= */}

        {!loading &&
          currentJobs.map((job) => {

            return (

              <div
                key={job.id}
                className="card mb-3 shadow-sm border-0"
              >

                <div className="card-body p-0">

                  {/* TOP */}

                  <div className="d-flex justify-content-between align-items-start m-3">

                    <div className="d-flex align-items-start gap-2">

                      <input
                        type="checkbox"
                        className="form-check-input job-checkbox mt-1"
                        checked={selectedIds.includes(job.id)}
                        onChange={() =>
                          handleToggleSelect(job.id)
                        }
                      />

                      <div>

                        <h6 className="mb-1">

                          Job Title : {job.title}

                        </h6>

                        <small className="admin-text-muted">

                          <TfiLocationPin />

                          {" "}

                          Location : {job.location}

                        </small>

                      </div>

                    </div>

                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        handlePreview(job)
                      }
                    >

                      Job Preview

                    </button>

                  </div>

                  {/* COUNTS */}

                  <div className="d-flex justify-content-center gap-3 my-2 flex-wrap">

                    <button
                      className="btn btn-sm btn-outline-primary d-flex flex-column align-items-center"
                      onClick={() =>
                        handleViewResponses(job)
                      }
                    >

                      <span className="fw-semibold">

                        {job.all_responses}

                      </span>

                      <span className="small">

                        Total Responses

                      </span>

                    </button>

                    <button className="btn btn-sm btn-outline-success d-flex flex-column align-items-center">

                      <span className="fw-semibold">

                        {job.shortlisted}

                      </span>

                      <span className="small">

                        Shortlist

                      </span>

                    </button>

                    <button className="btn btn-sm btn-outline-danger d-flex flex-column align-items-center">

                      <span className="fw-semibold">

                        {job.rejected}

                      </span>

                      <span className="small">

                        Rejected

                      </span>

                    </button>

                  </div>

                  {/* BOTTOM */}

                  <div className="d-flex justify-content-end flex-wrap gap-3 pb-3">

                    {/* HR DETAILS */}

                    <div className="admin-name-card">

                      <p>
                        {job.hrName}
                      </p>

                      <p>
                        {job.memberId}
                      </p>

                    </div>

                    {/* STATUS */}

                    <div className="px-2 admin-status-date">

                      <p className="badge bg-success">

                        {job.status}

                      </p>

                      <p className="admin-text-muted">

                        Posted :{" "}

                        <span className="posted-date">

                          {job.created_at

                            ? new Date(
                                job.created_at
                              ).toLocaleDateString()

                            : "N/A"}

                        </span>

                      </p>

                    </div>

                  </div>

                </div>

              </div>
            );
          })}

        {/* =========================================
            EMPTY DATA
        ========================================= */}

        {!loading &&
          currentJobs.length === 0 && (

          <div className="text-center py-5 text-muted">

            No Approved HR/Employee Jobs Available

          </div>

        )}

        {/* =========================================
            PAGINATION
        ========================================= */}

        {totalPages > 1 && (

          <div className="d-flex justify-content-between mt-4">

            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={page === 1}
              onClick={() =>
                setPage(page - 1)
              }
            >

              Previous

            </button>

            <div className="fw-bold">

              Page {page} of {totalPages}

            </div>

            <button
              className="btn btn-outline-secondary btn-sm"
              disabled={
                page === totalPages
              }
              onClick={() =>
                setPage(page + 1)
              }
            >

              Next

            </button>

          </div>

        )}

      </div>

    </section>
  );
}

export default EmployeejobList;